export default "__VITE_ASSET__D1kxs4el__"